import React from "react";
import SubscribeForm from "../SubscribeForm";

export default function Hero() {
    return (
        <section
            id="hero"
            data-testid="section-hero"
            style={{
                paddingTop: 64,
                paddingBottom: 96,
                position: "relative",
            }}
        >
            <div className="bt-shell">
                <div
                    className="bt-hero-grid"
                    style={{
                        display: "grid",
                        gridTemplateColumns: "1fr",
                        gap: 56,
                        alignItems: "start",
                    }}
                >
                    {/* Editorial column — headline-led, no decorative noise */}
                    <div>
                        <p
                            className="signal bt-enter bt-enter-1"
                            style={{ marginBottom: 36 }}
                        >
                            Independent &nbsp;·&nbsp; Free &nbsp;·&nbsp; Monthly
                        </p>

                        <h1
                            className="t-hero bt-enter bt-enter-2"
                            style={{
                                margin: 0,
                                marginBottom: 32,
                                maxWidth: 980,
                            }}
                        >
                            The retirement intel{" "}
                            <span
                                className="f-display-italic"
                                style={{
                                    color: "var(--bt-ink)",
                                    fontStyle: "italic",
                                    fontVariationSettings: '"opsz" 144, "SOFT" 0, "WONK" 1',
                                }}
                            >
                                Wall&nbsp;Street
                            </span>{" "}
                            won&rsquo;t put in writing.
                        </h1>

                        <p
                            className="t-lede bt-enter bt-enter-3"
                            style={{
                                margin: 0,
                                marginBottom: 48,
                                maxWidth: 620,
                            }}
                        >
                            A monthly read on the macro forces touching your savings,
                            the moves Wall Street is making with your money, and the
                            stories the financial press buries on page 12. Plain
                            English. Under 1,500 words. Sent the first Tuesday of the
                            month.
                        </p>

                        <div
                            className="bt-enter bt-enter-4"
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 28,
                                flexWrap: "wrap",
                            }}
                        >
                            <a
                                href="#recap"
                                className="arrow-link"
                                data-testid="hero-scroll-to-form"
                            >
                                Get the brief
                            </a>
                            <a
                                href="#sample-issue"
                                className="f-ui"
                                style={{
                                    fontSize: 14,
                                    color: "var(--bt-mute)",
                                    textDecoration: "none",
                                    letterSpacing: "0.01em",
                                }}
                            >
                                or read a sample first
                            </a>
                        </div>
                    </div>

                    {/* Form — stripped of decoration. Hangs in the gutter. */}
                    <aside
                        aria-label="Subscribe to the brief"
                        className="bt-enter bt-enter-3"
                        data-testid="hero-form-wrap"
                        style={{
                            paddingTop: 4,
                        }}
                    >
                        <p
                            className="marginalia"
                            style={{
                                margin: 0,
                                marginBottom: 18,
                                color: "var(--bt-mute)",
                            }}
                        >
                            Brief №&nbsp;001 ships next Tuesday
                        </p>
                        <hr
                            className="hairline"
                            style={{ marginBottom: 24, backgroundColor: "var(--bt-ink)" }}
                        />
                        <SubscribeForm instance="hero" />
                    </aside>
                </div>
            </div>
        </section>
    );
}
